import { render, staticRenderFns } from "./VlIndexPagination.vue?vue&type=template&id=be3aad30&scoped=true&"
import script from "./VlIndexPagination.vue?vue&type=script&lang=js&"
export * from "./VlIndexPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3aad30",
  null
  
)

export default component.exports